declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

const GA_ID = 'G-BW7JVB68EH';

export function trackEvent(action: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, { ...params });
  }
}

export function trackPageView(path: string) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_ID, { page_path: path });
  }
}

export const analytics = {
  signUp: (method: string) => trackEvent('sign_up', { method }),
  login: (method: string) => trackEvent('login', { method }),
  logout: () => trackEvent('logout'),

  diagramCreated: (type: string) => trackEvent('diagram_created', { diagram_type: type }),
  diagramExported: (format: string) => trackEvent('diagram_exported', { format }),
  diagramGenerated: (type: string) => trackEvent('ai_generation', { diagram_type: type }),
  autoFixTriggered: () => trackEvent('auto_fix_triggered'),

  projectCreated: () => trackEvent('project_created'),
  projectDeleted: () => trackEvent('project_deleted'),

  pageView: (page: string) => trackPageView(page),
  featureClicked: (feature: string) => trackEvent('feature_click', { feature }),
  ctaClicked: (cta: string) => trackEvent('cta_click', { cta_name: cta }),

  pricingViewed: () => trackEvent('pricing_viewed'),
  planSelected: (plan: string) => trackEvent('plan_selected', { plan }),
  subscriptionCreated: (plan: string) => trackEvent('subscription_created', { plan }),
  subscriptionCancelled: () => trackEvent('subscription_cancelled'),

  onboardingStarted: () => trackEvent('onboarding_started'),
  onboardingCompleted: (template: string) => trackEvent('onboarding_completed', { template }),
  onboardingSkipped: () => trackEvent('onboarding_skipped'),
};
